export const ClassNames = (names=[]) => {
  return names.filter(name => name !== '').map(name => name).join(' ').trim()
}